import React, { useState } from 'react';
import './Noticias.css';

const noticias = [
  {
    id: 6,
    categoria: 'ALIANZA',
    categoriaColor: 'info',
    fecha: '18 Oct 2026',
    titulo: 'ASODOFADE y VuelveACasa RD se unen en la búsqueda de personas desaparecidas',
    resumen: 'La Asociación Dominicana de Familiares de Desaparecidos (ASODOFADE) sostuvo un encuentro con VuelveACasa RD en un espacio de intercambio entre iniciativas que trabajan en torno a la desaparición de personas. Ambas organizaciones coinciden en que la cooperación permite compartir conocimientos, conectar esfuerzos y explorar nuevas posibilidades de apoyo a las familias. "Cuando se trata de buscar a una persona desaparecida, sumar esfuerzos importa."',
    imagen: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiIbkcIXp5cqdhlTVbGScjNwquRso5gkjwwKvlyoC9VXillNwSWhShjbh1_PwX7iO3e88Fcaw4CxIWc6y9JFsOqE5MYOWRMuW1mCtgODeQ4e5NG0TRsntk5wnZRka0RST5190aIGrgaCxWrfaKtEBTyBHJyuBprEbsxKwjmWE1IRekCzsz6vckecA9ZG2mQ/w345-h400/image.png',
    destacado: true
  },
  {
    id: 1,
    categoria: 'ENCONTRADO',
    categoriaColor: 'success',
    fecha: '14 Oct 2026',
    titulo: 'Sammy, 4 años, fue encontrado sano y salvo en Santo Domingo Este',
    resumen: 'Gracias a la rápida difusión en redes sociales y la colaboración de la comunidad, el pequeño Sammy fue localizado pocas horas después de su desaparición en Los Tres Brazos, Santo Domingo Este. Su familia agradece a todos los que compartieron su caso.',
    imagen: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhifey1Jb8wdaPZyL74UvfT5vou8tAnfL-KVaPQHNqWtf1Mj3hglpUA7FtyIU1OAPqAHa4TIwdhukj2Fold54ky1o5A9CsSyevw88sIWiiTMtiiNSVOvOJ67zUxm43jIv83u-h80OoC6thaY67oo9K4rVuVf3bqPRqRgVDs3L4enJfzh8TIocpin-L0p8Le/w149-h200/sammy_encontrado2.jpg',
    destacado: true
  },
  {
    id: 2,
    categoria: 'ENCONTRADO',
    categoriaColor: 'success',
    fecha: '12 Oct 2026',
    titulo: 'Amancio Elpidio Ruiz, 83 años, fue localizado con éxito',
    resumen: 'El adulto mayor desaparecido el 11 de octubre fue localizado gracias al trabajo conjunto de la comunidad y las autoridades. Toda la familia extiende su agradecimiento a quienes colaboraron en su búsqueda.',
    imagen: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh-hvtMNK70dRfeia4Ym02QaUs6_T5cGRkOWRnkEXCDE5BNmQZSjXfBFXOR7I6lgKsNTgtUAmqRP1RpsuBozzoykWFXsemWOqG3Khm77CRFPaqYDlYNQuW4ahLWEKT8wcAPS7WYJyRnJziC_j9XT0j2gF8bs9wvVj4bXGZ1Miqs5MEl6m6AnXEzWStunrJd/w152-h200/image.png',
    destacado: false
  },
  {
    id: 3,
    categoria: 'ACTUALIZACIÓN',
    categoriaColor: 'warning',
    fecha: '8 Oct 2026',
    titulo: 'El caso de Andrés Santana: 50 días desaparecido y hay registros médicos que generan interrogantes',
    resumen: 'A 50 días de la desaparición de Andrés Santana, su familia y nuestro equipo presentaron un registro que indica que fue atendido en el Hospital José Joaquín Puello cinco días después de desaparecer. Sin embargo, las cámaras de seguridad de esa hora no lo muestran. Seguimos buscando respuestas.',
    imagen: null,
    destacado: false
  },
  {
    id: 4,
    categoria: 'COMUNIDAD',
    categoriaColor: 'info',
    fecha: '1 Oct 2026',
    titulo: 'VuelveACasa RD se reúne con ASODOFADE para fortalecer la red de búsqueda nacional',
    resumen: 'Nuestro equipo sostuvo una reunión con la Asociación Dominicana de Familiares de Desaparecidos (ASODOFADE) para explorar alianzas que permitan ampliar el alcance de ambas organizaciones y brindar mejor apoyo a las familias afectadas en todo el país.',
    imagen: null,
    destacado: false
  },
  {
    id: 5,
    categoria: 'PLATAFORMA',
    categoriaColor: 'platform',
    fecha: '15 Sep 2026',
    titulo: 'VuelveACasa RD lanza su nueva plataforma digital con mapa interactivo de casos',
    resumen: 'Con el objetivo de mejorar la búsqueda de personas desaparecidas, hemos renovado completamente nuestra plataforma web. Ahora cuenta con un mapa interactivo que muestra los casos por provincia, búsqueda avanzada y una interfaz más accesible para las familias.',
    imagen: null,
    destacado: false
  }
];

const categorias = ['Todas', 'ENCONTRADO', 'ACTUALIZACIÓN', 'COMUNIDAD', 'PLATAFORMA', 'ALIANZA'];

function ShareButtons({ titulo, resumen, id }) {
  const url = `https://vuelveacasard.org/noticias#noticia-${id}`;
  const texto = encodeURIComponent(`${titulo} — ${resumen.slice(0, 100)}...`);
  const urlEnc = encodeURIComponent(url);

  const [copiado, setCopiado] = React.useState(false);

  const copiarEnlace = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    });
  };

  return (
    <div className="nt-share">
      <span className="nt-share-label">Compartir:</span>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${urlEnc}`}
        target="_blank"
        rel="noopener noreferrer"
        className="nt-share-btn nt-share-fb"
        title="Compartir en Facebook"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.791-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.268h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
        </svg>
        Facebook
      </a>
      <a
        href={`https://wa.me/?text=${texto}%20${urlEnc}`}
        target="_blank"
        rel="noopener noreferrer"
        className="nt-share-btn nt-share-wa"
        title="Compartir por WhatsApp"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        WhatsApp
      </a>
      <button
        onClick={copiarEnlace}
        className="nt-share-btn nt-share-copy"
        title="Copiar enlace"
      >
        {copiado ? '✓ Copiado' : '🔗 Copiar enlace'}
      </button>
    </div>
  );
}

export default function NoticiasPage() {
  const [filtro, setFiltro] = useState('Todas');

  const noticiasFiltradas = filtro === 'Todas'
    ? noticias
    : noticias.filter(n => n.categoria === filtro);

  const destacada = noticias.find(n => n.destacado);
  const resto = noticiasFiltradas.filter(n => !n.destacado || filtro !== 'Todas');

  return (
    <div className="nt-page">

      {/* Hero */}
      <section className="nt-hero">
        <div className="nt-hero-inner">
          <div className="nt-hero-badge">📰 Últimas Novedades</div>
          <h1>Noti<span className="nt-accent">cias</span></h1>
          <p className="nt-hero-sub">
            Casos resueltos, actualizaciones importantes y noticias de nuestra comunidad.
            Cada persona encontrada es una victoria que celebramos juntos.
          </p>
        </div>
      </section>

      <div className="nt-content">

        {/* Noticia destacada */}
        {filtro === 'Todas' && destacada && (
          <div className="nt-featured">
            <div className="nt-featured-badge">⭐ Noticia Destacada</div>
            <div className="nt-featured-card">
              {destacada.imagen && (
                <div className="nt-featured-img-wrap">
                  <img src={destacada.imagen} alt={destacada.titulo} className="nt-featured-img" />
                </div>
              )}
              <div className="nt-featured-body">
                <div className="nt-featured-meta">
                  <span className={`nt-cat nt-cat-${destacada.categoriaColor}`}>{destacada.categoria}</span>
                  <span className="nt-fecha">📅 {destacada.fecha}</span>
                </div>
                <h2>{destacada.titulo}</h2>
                <p>{destacada.resumen}</p>
                <ShareButtons titulo={destacada.titulo} resumen={destacada.resumen} id={destacada.id} />
              </div>
            </div>
          </div>
        )}

        {/* Filtros */}
        <div className="nt-filtros">
          {categorias.map(cat => (
            <button
              key={cat}
              className={`nt-filtro-btn ${filtro === cat ? 'nt-filtro-active' : ''}`}
              onClick={() => setFiltro(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Lista de noticias */}
        <div className="nt-list">
          {resto.map(noticia => (
            <article key={noticia.id} className="nt-card">
              {noticia.imagen && (
                <div className="nt-card-img-wrap">
                  <img src={noticia.imagen} alt={noticia.titulo} className="nt-card-img" />
                </div>
              )}
              <div className="nt-card-body">
                <div className="nt-card-meta">
                  <span className={`nt-cat nt-cat-${noticia.categoriaColor}`}>{noticia.categoria}</span>
                  <span className="nt-fecha">📅 {noticia.fecha}</span>
                </div>
                <h3>{noticia.titulo}</h3>
                <p>{noticia.resumen}</p>
                <ShareButtons titulo={noticia.titulo} resumen={noticia.resumen} id={noticia.id} />
              </div>
            </article>
          ))}

          {noticiasFiltradas.length === 0 && (
            <div className="nt-empty">
              <span>📭</span>
              <p>No hay noticias en esta categoría todavía.</p>
            </div>
          )}
        </div>

        {/* Colabora box */}
        <div className="nt-colabora">
          <div className="nt-colabora-inner">
            <span className="nt-colabora-icon">🤝</span>
            <div className="nt-colabora-text">
              <h3>¿Tienes información sobre un caso?</h3>
              <p>Comparte lo que sabes. Tu información puede ayudar a reunir a una familia.</p>
            </div>
            <a
              href="https://wa.me/18092668206"
              target="_blank"
              rel="noopener noreferrer"
              className="nt-colabora-btn"
            >
              Contactar por WhatsApp
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}
